import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import './App.scss';
import AboutUs from './components/AboutUs';
import Cart from './components/Cart';
import ContactUs from './components/ContactUs';
import Home from './components/Home';
import IndividualProductPage from './components/IndividualProductPage';
import NavForDesktop from './components/NavForDesktop';
import ProductsPage from './components/ProductsPage';
import Winery from './components/Winery';
import { useStateValue } from './context/StateProvider';
import useOutsideClick from './hooks/useOutsideClick';
import { actionTypes } from './context/reducer';
import './mystyles.scss';
import Footer from './components/Footer/Footer';
import DesignMyWine from './components/DesignMyWine';
import Success from './components/Success';
import Cancel from './components/Cancel';

const ENABLE_BACKEND = true;

function App() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [{ products }, dispatch] = useStateValue();

  useEffect(() => {
    const getProducts = async () => {
      if (ENABLE_BACKEND) {
        const response = await axios.get('/products');
        console.log(response.data);
        dispatch({
          type: actionTypes.UPDATE_PRODUCTS,
          products: response.data
        });
      }
    };
    getProducts();
  }, [dispatch]);

  const drawerHandler = () => {
    setOpenDrawer(!openDrawer);
  };

  const ref = useRef();

  useOutsideClick(ref, () => {
    drawerHandler();
  });

  return (
    <div className="App">
      <NavForDesktop />
      {/* <div ref={openDrawer ? ref : null}>
        <NavForMobile openDrawer={openDrawer} drawerHandler={drawerHandler} />
      </div> */}
      <Switch>
        <Route path="/success">
          <Success />
        </Route>
        <Route path="/cancel">
          <Cancel />
        </Route>
        <Route path="/designwine">
          <DesignMyWine />
        </Route>
        <Route path="/products">
          <ProductsPage />
        </Route>
        <Route path="/winery">
          <Winery />
        </Route>
        <Route path="/about">
          <AboutUs />
        </Route>
        <Route path="/contact">
          <ContactUs />
        </Route>
        {/* <Route path="/customizer">
          <CustomizerContainer />
        </Route> */}
        <Route path="/product/:id">
          <IndividualProductPage />
        </Route>
        <Route path="/cart">
          <Cart />
        </Route>
        <Route path="/">
          <Home />
        </Route>
      </Switch>
      <Footer />
    </div>
  );
}

export default App;
